module.exports = __webpack_public_path__ + "img/shield_blue.6e16d850.png";